<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/client/my-portfolio">
    <!-- Total Deals -->
    <app-card variant="elevated" rootClass="h-full" class="h-full">
        <div class="flex flex-col gap-3 p-3">
            <!-- HEADER -->
            <div class="flex items-start justify-between">
                <span class="title-text-primary text-subheading-large">
                    Amount Invested
                    <!-- {{ 'ADMIN.DASHBOARD.STATS.TOTAL_DEALS' | translate }} -->
                </span>

                <svg-icon src="./icons/portFolio.svg" svgClass="w-6 h-6"></svg-icon>
            </div>
            <!-- VALUE -->
            <div class="text-heading-large text-primaryText">
                @if (summaryLoading()) { 
                <p-skeleton height="32px" width="70px" />
                } @else {
                @if (summaryData()?.portfolioValue) {
                  <app-currency-display
                    [value]="summaryData()!.portfolioValue"
                    [currencyCode]="summaryData()?.usdCurrency || 'USD'"
                    [compact]="true"
                  />
                } @else {
                  -
                }
                }
            </div>
            <!-- DESCRIPTION -->
            <!-- <span class="text-body-large text-bodyText">
                <span class="text-success">+11,2% </span>
                total return
            </span> -->
        </div>
    </app-card>
</div>

<!-- Total WMs -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/client/deals/live">
    <app-card variant="elevated" rootClass="h-full" class="h-full">

        <div class="flex flex-col gap-3 p-3">

            <!-- HEADER -->
            <div class="flex items-start justify-between">
                <span class="title-text-primary text-subheading-large">
                    Active Investments
                    <!-- {{ 'ADMIN.DASHBOARD.STATS.TOTAL_WM' | translate }} -->
                </span>

                <svg-icon src="./icons/active-investment.svg" svgClass="w-6 h-6"></svg-icon>
            </div>

            <!-- VALUE -->
            <div class="text-heading-large text-primaryText">
                @if (summaryLoading()) {
                <p-skeleton height="32px" width="70px" />
                    } @else {                    
                {{ summaryData()?.activeInvestmentsCount ? summaryData()?.activeInvestmentsCount : '-' }}
                }
            </div>

            <!-- DESCRIPTION -->
            <span class="text-body-large text-bodyText">
                Portfolio Investments
                <!-- {{ 'ADMIN.DASHBOARD.STATS.TOTAL_WM_DESCRIPTION' | translate }} -->
            </span>

        </div>

    </app-card>
</div>

<!-- Total RMs -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/client/deals">
    <app-card variant="elevated" rootClass="h-full" class="h-full">

        <div class="flex flex-col gap-3 p-3">

            <!-- HEADER -->
            <div class="flex items-start justify-between">
                <span class="title-text-primary text-subheading-large">
                    Open Deals
                    <!-- {{ 'ADMIN.DASHBOARD.STATS.TOTAL_RM' | translate }} -->
                </span>

                <svg-icon src="./icons/live_opportunities.svg" svgClass="w-6 h-6"></svg-icon>
            </div>

            <!-- VALUE -->
            <div class="text-heading-large text-primaryText">
                @if (summaryLoading()) {
                <p-skeleton height="32px" width="70px" />
                } @else {
                {{ summaryData()?.open ? summaryData()?.open : '-' }}
                }
            </div>

            <!-- DESCRIPTION -->
            <span class="text-body-large text-bodyText">
                Shared by your RM
                <!-- {{ 'ADMIN.DASHBOARD.STATS.TOTAL_RM_DESCRIPTION' | translate }} -->
            </span>

        </div>

    </app-card>

</div>

<!-- Client AUM -->
<div class="col-span-12 lg:col-span-6 xl:col-span-3 cursor-pointer" routerLink="/user-profile" [queryParams]="{ tab: 'deal-preferences' }">
    <app-card variant="elevated" rootClass="h-full" class="h-full">

        <div class="flex flex-col gap-3 p-3 pb-0">

            <!-- HEADER -->
            <div class="flex items-start justify-between">
                <span class="title-text-primary text-subheading-large">
                    My Preferences
                    <!-- {{ 'ADMIN.DASHBOARD.STATS.CLIENT_AUM' | translate }} -->
                </span>

                <svg-icon src="./icons/preference.svg" width="20" height="20">
                </svg-icon>
            </div>

            <!-- VALUE -->
            <div class="text-heading-large text-primaryText">
                @if (summaryLoading()) {
                <p-skeleton height="32px" width="90px" />
                } @else {
                <div class="flex flex-col gap-4">
                    <div class="flex items-center gap-2">
                        <svg-icon src="./icons/private_equity.svg" svgClass="w-4 h-4"></svg-icon>
                        <span class="text-body-large text-bodyText">Private Equity</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <svg-icon src="./icons/private_credit.svg" svgClass="w-4 h-4"></svg-icon>
                        <span class="text-body-large text-bodyText">Private Credit</span>
                    </div>
                    <div class="flex items-center gap-2">
                        <svg-icon src="./icons/commodities.svg" svgClass="w-4 h-4"></svg-icon>
                        <span class="text-body-large text-bodyText">Commodities</span>
                    </div>
                </div>
                }
            </div>
        </div>

    </app-card>

</div>
